import qs from "qs"
import {DealCategory, DealsTag, DealListSort, DealType} from "@irati/types"
import omitEmpty from "@irati/utils/omitEmpty"
import {ERROR_CATEGORY, ALL_CATEGORY} from "../../components/DealList/BadCategoryOrTag"

type RawFilteringParams = {
  tags?: string
  type?: string
  sort?: DealListSort
  regions?: string
}

export type FilteringParams = {
  category?: DealCategory
  tags?: DealsTag[]
  type?: TypeOption
  sort?: DealListSort
  regions?: string[]
}

export type TypeOption = {
  uuid: string
  name: string
  value: DealType[]
}

export function getSelectedCategory(categories: DealCategory[], categoryUrl?: string): DealCategory {
  if (!categoryUrl) {
    return ALL_CATEGORY
  }

  const selected = categories.filter((item) => item.url === categoryUrl)[0]

  return selected || ERROR_CATEGORY
}

export function getSelectedTags(category: DealCategory, tagsFromQuery?: string): DealsTag[] {
  if (!category) {
    return []
  }
  const {tags} = category

  if (!tagsFromQuery) {
    return tags
  }

  return tags.filter((tag) => tagsFromQuery.indexOf(tag.url) > -1)
}

function getSelectedDealType(dealTypeOptions: TypeOption[], typeFromQuery?: string): TypeOption | undefined {
  return dealTypeOptions.find((option) => option.uuid === typeFromQuery)
}

function getSortOption(sortOptions: DealListSort[], sortFromQuery?: DealListSort) {
  return sortFromQuery && sortOptions.includes(sortFromQuery) ? sortFromQuery : undefined
}

export function fromQuery(dealTypes: TypeOption[], categories: DealCategory[], category?: string): FilteringParams {
  const params: RawFilteringParams = qs.parse(location.href.split("?")[1])

  const {type, tags, regions} = params
  const selectedCategory = getSelectedCategory(categories, category)

  return {
    ...params,
    type: getSelectedDealType(dealTypes, type),
    category: selectedCategory,
    tags: getSelectedTags(selectedCategory, tags),
    regions: regions?.split(" ")
  }
}

export function toQuery(filters: FilteringParams, changes: {[key: string]: string | string[]}, sortOptions: DealListSort[]): string {
  let selectedTags: string[] = []
  const rawQuery: RawFilteringParams = qs.parse(location.href.split("?")[1])
  const {tags, type, sort, regions} = filters

  if (tags && rawQuery?.tags) {
    const tagsUuids = tags.map((tag) => tag.url)
    selectedTags = tagsUuids.filter((tag) => rawQuery?.tags?.indexOf(tag!) !== -1) || []
  }

  const formattedFilters = {
    tags: changes.tags || selectedTags,
    type: changes.type !== undefined ? changes.type : type?.uuid,
    sort: changes.sort || getSortOption(sortOptions, sort),
    regions: (changes.regions || regions || []).join(" ")
  }

  return qs.stringify(omitEmpty({...formattedFilters, tags: formattedFilters.tags.join(" ")}))
}
